<div class="webchat-settings" fxFlex fxLayout="column">
  <p [innerHTML]="noteHtml"></p>
  <mat-checkbox
    class="checkbox"
    [(ngModel)]="webchatSettings.visible"
    (change)="onCheck()"
    [matTooltip]="botonicVersionTooltip"
    [matTooltipPosition]="'right'"
  >
    {{ visibleLabel }}
  </mat-checkbox>
  <app-whitelisted-urls
    [text]="getWhitelistedUrlsText()"
    [matTooltip]="whitelistedUrlsTooltip"
    matTooltipPosition="right"
    (whitelistedUrlsFilled)="onWhitelistedUrlsFilled($event)"
  ></app-whitelisted-urls>

  <app-queue-selector
    [title]="scheduleFromQueueTitle"
    [allowNone]="true"
    [required]="false"
    [hint]="queueHoursHint"
    [projectQueuesGroups]="projectQueuesGroups"
    (selectedQueueId)="onSelectedQueueId($event)"
    [matTooltip]="botonicVersionTooltip"
    matTooltipPosition="right"
  ></app-queue-selector>
  @if (showCurrentQueue) {
    <h5>
      {{ scheduledToLabel }} <strong>{{ getQueueInfo() }}</strong>
    </h5>
  }
</div>
